// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--26TMa";
export var contactEmail = "contact-module--contact-email--15dEA";
export var contactInfo = "contact-module--contact-info--3RlDr";
export var contactSend = "contact-module--contact-send--3WRp-";
export var icon = "contact-module--icon--2LSDT";
export var address = "contact-module--address--32vQO";
export var contactSummary = "contact-module--contact-summary--1G0Ly";